import { useMemo } from 'react';
import useUserPermissions from './useUserPermissions';
import useMe from './useMe';
import { DEFAULT_PERMISSIONS_LIST } from '../constants/permissionsList';

function useSidebarRoutes(routes, type = DEFAULT_PERMISSIONS_LIST) {
  const { data: permissions = [] } = useUserPermissions(type);
  const { data: currentUser } = useMe();

  return useMemo(() => {
    if (!routes || !permissions || !currentUser) {
      return [];
    }

    const isAllowed = (endpointOrGroup) => {
      if (Array.isArray(endpointOrGroup)) {
        return endpointOrGroup.every((ep) => {
          const perm = permissions.find((p) => p.key === ep);

          return perm?.status;
        });
      }

      const perm = permissions.find((p) => p.key === endpointOrGroup);

      return perm?.status;
    };

    return routes.filter((route) => {
      if (['Admin'].includes(currentUser.role)) {
        return true;
      }

      // Check flat endpoints if present
      if (
        (route.endpoints || []).some(
          (ep) => permissions.find((p) => p.key === ep)?.status,
        )
      ) {
        return true;
      }

      // Check tabEndpoints
      return (route.tabEndpoints || []).some((tab) =>
        (tab.endpoints || []).some(isAllowed),
      );
    });
  }, [routes, permissions, currentUser]);
}

export default useSidebarRoutes;
